import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { requestApi } from 'utils/request';
import StyledActiveButton from 'components/Button/StyledActiveButton';
import DataProviderLinkInfo from './DataProviderLinkInfo';
import Layout from 'layout';
import CommonModal from 'components/Modal/CommonModal';
import { FirstText, TextBlue } from '../../style';
import {
  BlueLink,
  ChildText,
  ChildTextContent,
  ChildTextContent2,
  ContentBox,
  SelectOption,
  SelectProvider,
} from '../style';
import { DataProviderRequestContainer } from './style';
import { COMMON_ERR_MESSAGE } from 'constants/message';
import ROUTE_PATH from '../../../../routes/config';
import { TAB_VALUES } from '../../DataLinkageManage/constants';
import { useApp } from 'contexts/AppContext';
import { useUI } from 'contexts/UIContext';
import CustomerFooter from 'components/CustomerFooter';

// 데이터 제공사를 통한 데이터 연동
const DataLinkageDataProviderRequestPage = () => {
  const { setContextLoading } = useUI();
  const navigate = useNavigate();
  const { auth } = useApp();
  const { businessName, businessRegistrationNumber } = auth;
  const [dataProviderList, setDataProviderList] = useState([]);
  const [dataProviderInfo, setDataProviderInfo] = useState({});
  const [modalData, setModalData] = useState(null);

  // 데이터 제공사 선택
  const onChangeSelectProvider = event => {
    const { value, selectedIndex } = event.target;
    const extraValue =
      event.target.options[selectedIndex].getAttribute('data-extra');
    setDataProviderInfo({
      ...dataProviderInfo,
      dataProviderSeq: value,
      dataProviderName: extraValue,
    });
  };

  // 데이터 제공사 목록 조회 api
  const fetchDataProviderList = async () => {
    try {
      const res = await requestApi({
        url: '/v1/au/data-provider/using-data-provider-list',
        method: 'GET',
      });
      setDataProviderList([
        {
          label: '데이터 제공사 선택',
          value: '',
        },
        ...res.data.list
          ?.filter(item => item.dataProviderSeq !== 10002)
          ?.map(item => ({
            label: item.dataProviderName,
            value: item.dataProviderSeq,
          })),
      ]);
    } catch (error) {
      console.error(error);
    } finally {
      setContextLoading(false);
    }
  };

  // 데이터 연동 api
  const fetchDataLinkage = async () => {
    try {
      const res = await requestApi({
        url: '/v1/au/data-provider/interlock/business',
        method: 'POST',
        data: {
          dataProviderSeq: Number(dataProviderInfo.dataProviderSeq),
          dataProviderId: dataProviderInfo.dataProviderId,
          dataProviderPassword: dataProviderInfo.dataProviderPassword,
        },
      });
      setModalData({
        contents: res.message,
        onClickCloseBtn: () => {
          navigate({
            pathname: ROUTE_PATH.mypage.dataLinkageManage,
            search: `?tab=${TAB_VALUES.DATA_PROVIDER}`,
          });
        },
      });
    } catch (error) {
      console.error(error);
      if (error.response.data.errorCode === 500) {
        setModalData({
          contents: error.response.data.message,
        });
      } else {
        setModalData({
          contents: COMMON_ERR_MESSAGE,
        });
      }
    }
  };

  useEffect(() => {
    (async () => await fetchDataProviderList())();
  }, []);

  return (
    <Layout isShowBannerPage={false} pageTitle="데이터 연동">
      <DataProviderRequestContainer>
        <div className="wrapBox">
          <FirstText>
            <TextBlue>{businessName}</TextBlue>님 데이터 제공사 정보를 입력 후
            <br />
            데이터 연동을 진행해 주세요.
          </FirstText>
          <ContentBox>
            <ChildText>
              <ChildTextContent bold>사업자 번호</ChildTextContent>
              <ChildTextContent>{businessRegistrationNumber}</ChildTextContent>
            </ChildText>
            <ChildText>
              <ChildTextContent bold>연동 정보</ChildTextContent>
              <ChildTextContent>데이터 제공사 연동</ChildTextContent>
            </ChildText>
            <SelectProvider
              onChange={onChangeSelectProvider}
              value={dataProviderInfo.dataProviderSeq}
            >
              {dataProviderList?.map((item, index) => (
                <SelectOption
                  key={`SelectOption_${item.value}_${index}`}
                  value={item.value}
                  data-extra={item.label}
                >
                  {item.label}
                </SelectOption>
              ))}
            </SelectProvider>

            {dataProviderInfo.dataProviderSeq && (
              <>
                <DataProviderLinkInfo
                  dataProviderInfo={dataProviderInfo}
                  setDataProviderInfo={setDataProviderInfo}
                />
                <ChildText>
                  <ChildTextContent2>
                    아직 {dataProviderInfo.dataProviderName} 회원이 아니라면?{' '}
                    <BlueLink
                      href="/"
                      target="_blank"
                      tabIndex={0}
                      title="데이터제공사 사이트의 회원가입 팝업창 오픈"
                    >
                      {dataProviderInfo.dataProviderName} 회원가입
                    </BlueLink>
                  </ChildTextContent2>
                </ChildText>
                <StyledActiveButton
                  onClick={fetchDataLinkage}
                  margin="0 0 36px"
                >
                  판매몰 계정 확인
                </StyledActiveButton>
              </>
            )}
          </ContentBox>
          <CommonModal
            modalData={modalData}
            showModal={!!modalData}
            setShowModal={() => setModalData(null)}
          />
        </div>
        <CustomerFooter />
      </DataProviderRequestContainer>
    </Layout>
  );
};

export default DataLinkageDataProviderRequestPage;
